import Image from "next/image";
import { FBProductType } from "../data/passticket_type";
import { BLUR_DATAURL } from "../constants";
import { chnageKey, numberFormatter } from "./get_rates";
import { FC } from "react";

export interface PassTicketsComponentProps {
  className?: string;
  area: string;
  items: Array<FBProductType>;
  itemId: string,
  isProduct: boolean,
}

export const PassTicketsComponent: FC<PassTicketsComponentProps> = ({ className, area, items, itemId, isProduct }) => {
  const sortedItem = items.filter((item) => item.id === itemId)[0];
  if (sortedItem == null) {
    return <></>;
  }
  return <>
    <div className={`rounded-2xl border border-neutral-200 bg-white ${className}`}>
      <div className="p-1 my-1 mx-2 space-y-2">
        <p className="m-0">{`${sortedItem.kr} ${isProduct ? "가격비교" : ""}`}</p>
        <div className="grid grid-cols-3 place-items-center">
          <Image className="rounded-2xl my-1 shadow-md"
            unoptimized={true}
            alt={sortedItem.kr}
            width={100}
            height={100}
            src={`/passtickets/${area}/${sortedItem.id}.webp`}
            placeholder="blur"
            blurDataURL={BLUR_DATAURL}
          />
          <div className={`col-span-2 overflow-y-auto space-y-1 h-28 w-full`}>
            {sortedItem.prices.map((item, index) => (
              item.price !== 0 ?
                <div key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="no-underline">
                    <div className="rounded-lg shadow p-1 m-2">
                      <div className="flex justify-between text-sm mx-2 font-medium text-primary-400">
                        <div className="flex items-center">
                          {chnageKey(item.type)}
                          &nbsp;
                          <svg
                            width={15}
                            height={15}
                            data-slot="icon" fill="none" strokeWidth="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
                          </svg>
                        </div>
                        <div>{numberFormatter.format(item.price)}</div>
                      </div>
                    </div>
                  </a>
                </div> : <div key={index}></div>
            ))}
          </div>
        </div>

        {/* {isProduct ? <></> : <>
          <div className="text-xs text-gray-500 space-y-1">
            {sortedItem.descs.map((item, index) => (
              <p key={index} className="leading-3 font-normal">
                {item}
              </p>
            ))}
          </div>
          <div className="text-xs text-red-500 space-y-1">
            {sortedItem.cautions.map((item, index) => (
              <p key={index} className="leading-3 font-normal">
                {item}
              </p>
            ))}
          </div>
        </>} */}
        <div className="space-y-1">
          <div className="text-xs text-neutral-500 font-light">
            {sortedItem.descs.map((item, index) => (
              <span key={index} className="leading-3 font-normal">
                {item}<br />
              </span>
            ))}
          </div>
          <div className="text-xs text-red-300">
            {sortedItem.cautions.map((item, index) => (
              <span key={index} className="leading-3 font-normal">
                {item}<br />
              </span>
            ))}
          </div>
        </div>
      </div>
    </div >
  </>;
}

export default PassTicketsComponent;